import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIcon from '@mui/icons-material/Assignment';
import StockAdjustmentRegModal from "../../../../modal/PC/stock/StockAdjustmentRegModal";
import StockAdjustmentDetailModal from "../../../../modal/PC/stock/StockAdjustmentDetailModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';

const StockAdjustment = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        search:'',
        type:''
    });
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isDetailModalOpen, setDetailModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectStockAdjustmentID, setSelectStockAdjustmentID] = useState('');
    const [typeOption, setTypeOption] = useState([]);
    const [typeModalOption, setTypeModalOption] = useState([]);
    const [paramID, setParamID] = useState('');
    const [initialEditOpenDone, setInitialEditOpenDone] = useState(true);

    // Grid정의
    const handleSetting = () => {
        setColumns([
            {
                field: 'viewer',
                headerName: '상세',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<AssignmentIcon color={"primary"} />} onClick={() => {DetailClick(params)}} label="Viewer" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'stock_adjustment_id', width: 0, headerAlign: 'center' },
            { field: 'stock_adjustment_number', headerName: '재고조정번호', width: 120, headerAlign: 'center', align:'center'},
            { field: 'stock_adjustment_type', headerName: 'stock_adjustment_type', width: 0, headerAlign: 'center'},
            { field: 'stock_adjustment_type_name', headerName: '유형', width: 120, headerAlign: 'center', align:'center'},
            { field: 'stock_adjustment_reason', headerName: '재고조정사유', width: 730, headerAlign: 'center', align:'left'},
            { field: 'stock_adjustment_use_cnt', headerName: 'stock_adjustment_use_cnt', width: 0, headerAlign: 'center'},
            { field: 'stock_adjustment_approval_user_id', headerName: 'stock_adjustment_approval_user_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'stock_adjustment_approval_user_name', headerName: '승인자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_user_id', headerName: 'reg_user_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'recent_update_datetime', headerName: '최근수정일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        stock_adjustment_number: true,
        stock_adjustment_type: false,
        stock_adjustment_type_name: true,
        stock_adjustment_reason: true,
        stock_adjustment_approval_user_id: false,
        stock_adjustment_approval_user_name: true,
        stock_adjustment_use_cnt: false,
        deleted: true,
        viewer: true,
        reg_user_id: false,
        reg_user_name: true,
        recent_update_datetime: true,
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            
            if(params.stock_adjustment_id !== null && typeof params.stock_adjustment_id !== 'undefined'){
                setParamID(params.stock_adjustment_id);
            }
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
            timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.type])

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleView();
        }
    }, [MenuID]);

    useEffect(() => {
        if (originRows.length > 0 && paramID && initialEditOpenDone) {
            const filtered = originRows.filter(row => String(row.stock_adjustment_id) === String(paramID));

            if (filtered.length > 0) {
                setSelectStockAdjustmentID(paramID);
                setDetailModalOpen(true);
                setModalTitle('재고조정 상세');
                setInitialEditOpenDone(false);
            }
        }
    }, [originRows, paramID]);
    
    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/StockAdjustment/List',
            {
            params : {
              search : keyword.search,
              type : keyword.type
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.stock_adjustment_id]) {
                    PermissionMap[row.stock_adjustment_id] = [row.reg_user_id, row.update_user_id, row.stock_adjustment_approval_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            var array = response.data.map((item, index) => ({
                id: item.stock_adjustment_id,
                stock_adjustment_number: item.stock_adjustment_number,
                stock_adjustment_type: item.stock_adjustment_type,
                stock_adjustment_type_name: item.stock_adjustment_type_name,
                stock_adjustment_reason: item.stock_adjustment_reason,
                stock_adjustment_approval_user_id: item.stock_adjustment_approval_user_id,
                stock_adjustment_approval_user_name: item.stock_adjustment_approval_user_name,
                stock_adjustment_use_cnt: item.stock_adjustment_use_cnt,
                reg_user_id: item.reg_user_id,
                reg_user_name: item.reg_user_name,
                recent_update_datetime: (item.update_datetime === undefined?Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss'):Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_flag: PermissionMap[item.stock_adjustment_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    }

    const handleInitSelect = () => {
        
        // 재고조정유형
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 
            var type_array = [];
            var type_array_modal = [];

            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0023'){
                    type_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                    type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }

            type_array.unshift({ value: '', label : '유형'});
            setTypeModalOption(type_array_modal);
            setTypeOption(type_array);
        })
        .catch((error) => {
            console.log(error);
        });        
    }

    const handleInit = () => {
        setKeyword({
            search: '',
            type: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            stock_adjustment_number: true,
            stock_adjustment_type: false,
            stock_adjustment_type_name: true,
            stock_adjustment_reason: true,
            stock_adjustment_approval_user_id: false,
            stock_adjustment_approval_user_name: true,
            stock_adjustment_use_cnt: false,
            deleted: true,
            viewer: true,
            reg_user_id: false,
            reg_user_name: true,
            recent_update_datetime: true,
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('재고조정 등록');
    };
    
    const DetailClick = (object) => {
        setDetailModalOpen(true);
        setModalTitle('재고조정 상세');
        setSelectStockAdjustmentID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '재고조정번호 '+object.row.stock_adjustment_number+' 삭제',
            html : '재고조정번호 '+object.row.stock_adjustment_number+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/StockAdjustment/Delete', new URLSearchParams({
                    delete_stock_adjustment_id: object.row.id,
                    folder: 'StockAdjustment'
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){

                        Swal.fire({
                            title: '재고조정번호 '+object.row.stock_adjustment_number+' 삭제 완료',
                            text: '정상적으로 재고조정번호 '+object.row.stock_adjustment_number+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false); 
                });
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const handleRegSuccessSave = (regID) => {
        setModalTitle('재고조정 상세');
        setRegModalOpen(false);
        handleView();
        
        Swal.fire({
            title: '재고조정 등록 완료',
            text: '정상적으로 재고조정이 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setDetailModalOpen(true);
            setSelectStockAdjustmentID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '재고조정'
        axios.get('/api/p/StockAdjustment/Excel',
        {   
            params : { search : keyword.search, type : keyword.type, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y'&& (
                        <StockAdjustmentRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        typeModalOption={typeModalOption}
                        handleRegSuccessSave={handleRegSuccessSave}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            유형
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="유형" onChange={(e) => onSelectChange('type',e.value)} value={typeOption.filter(function (option) { return option.value === keyword.type;  })} options={typeOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="none" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isDetailModalOpen && (
                        <StockAdjustmentDetailModal
                        onClose={() => {
                            setDetailModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectStockAdjustmentID}
                        typeModalOption={typeModalOption}
                        originRows={originRows.filter(row => String(row.stock_adjustment_id) === String(selectStockAdjustmentID))}
                        handleView={handleView}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default StockAdjustment;
